import { Classes, Colors } from '@blueprintjs/core';
import * as React from 'react';

interface Props {
  message: string;
  onRetry: () => void;
}

export default function RetryHelpText({ message, onRetry }: Props) {
  return (
    <div
      className={`${Classes.FORM_HELPER_TEXT} ${Classes.TEXT_SMALL}`}
      style={{ color: Colors.ORANGE2, marginTop: 5 }}
    >
      {message}{' '}
      <a
        href="#"
        onClick={(event) => {
          event.preventDefault();
          onRetry();
        }}
      >
        Retry
      </a>
    </div>
  );
}
